import { render, staticRenderFns } from "./project-listing.vue?vue&type=template&id=afd36400&"
import script from "./project-listing.vue?vue&type=script&lang=ts&"
export * from "./project-listing.vue?vue&type=script&lang=ts&"
import style0 from "./project-listing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports